<template>
  <loadList :loading="loading" @load="$emit('load')" @fixed="(value) => $emit('fixed', value)">
    <job
      v-for="(item, index) in list"
      :key="index"
      :job="item"
      :apply-now="applyNow"
      :source="source"
      :width="width"
      :height="height"
      @applyed="applyed"
    ></job>
  </loadList>
</template>

<script>
import job from './job.vue'
import loadList from './loadList.vue'

export default {
  components: { loadList, job },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => {}
    },
    applyNow: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      default: 686
    },
    height: {
      type: [String, Number],
      default: 517
    }
  },
  methods: {
    applyed(data) {
      this.$emit('applyed', data)
    }
  }
}
</script>
